import React from 'react';

import styled from 'styled-components';

import {InlineExclusiveGatewayIcon} from 'app/procedures/components/step-types-icons';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';
import {capitalizeFirstLetter} from 'app/utils/strings';

import type {ElementType} from 'react';
import type {ContentType} from 'sweet-types';

const StyledContainerSpan = styled.span`
  .badge {
    &.empty {
      opacity: 0.25;
    }
  }
`;

export interface BadgeRelation {
  ct: ContentType;
  getter: (p) => Array<unknown> | void;
  Component: ElementType;
}

type Props<T> = {
  object: T;
  className?: string;
  onToggle: (contentType, boolean) => void;
  activeRelations?: Record<ContentType, boolean>;
  relations: Array<BadgeRelation>;
};

export function ItemRelationsBadges<T>({
  object,
  relations,
  activeRelations,
  onToggle,
  className,
  ...other
}: Props<T>) {
  return (
    <StyledContainerSpan className={`${className}`} {...other}>
      {relations.map(({ct, getter}) => {
        const items = getter(object);

        if (items == null) {
          // don't bother showing a count at all for
          // procedures without the type defined.
          return null;
        }

        const emptyClass = items.length === 0 ? 'empty' : '';
        const isActive = activeRelations != null && activeRelations[ct];
        const contentType =
          ct === 'decision'
            ? {
                name: 'decision',
                pluralName: gt('Decisions'),
                icon: (
                  <InlineExclusiveGatewayIcon
                    fill={isActive ? '#fff' : '#000'}
                  />
                ),
              }
            : getContentType(ct);

        return (
          <button
            key={ct}
            onClick={() => onToggle(ct, !isActive)}
            title={capitalizeFirstLetter(contentType.pluralName)}
            className={`btn ml-1 badge badge-${
              isActive ? 'secondary' : 'light'
            } ${emptyClass}`}
          >
            {contentType.name == 'decision' ? (
              contentType.icon
            ) : (
              <i className={`fa ${contentType.icon}`} />
            )}{' '}
            {items.length}
          </button>
        );
      })}
    </StyledContainerSpan>
  );
}
